module.exports = __webpack_public_path__ + "static/media/Decisions_Step5_Image4.62e28e22.webp";